export default __webpack_public_path__ + "9fe058df54591587efe84f8f4754ea63.png";